import type { SignalRow } from '../../lib/signalTable';

const dot: Record<SignalRow['status'], string> = {
  ok: 'bg-emerald-500',
  warn: 'bg-amber-500',
  error: 'bg-red-500',
  info: 'bg-black/25 dark:bg-white/25',
};
const text: Record<SignalRow['status'], string> = {
  ok: 'text-emerald-600 dark:text-emerald-400',
  warn: 'text-amber-600 dark:text-amber-400',
  error: 'text-red-600 dark:text-red-400',
  info: 'text-black/45 dark:text-white/45',
};

// One line per Signal the mapping makes. A click selects it (its fields open
// below); the list scrolls instead of paging.
export function SignalTable({ rows, selected, onSelect }: { rows: SignalRow[]; selected: number | null; onSelect: (index: number) => void }) {
  return (
    <div role="table" aria-label="Signals" className="max-h-80 overflow-auto rounded-xl border border-black/10 dark:border-white/10">
      <div role="row" className="sticky top-0 grid grid-cols-[minmax(7rem,1.2fr)_minmax(6rem,1fr)_minmax(5rem,1fr)_minmax(5rem,0.8fr)_minmax(6rem,0.9fr)] gap-2 bg-white dark:bg-neutral-900 px-3 py-1.5 text-[11px] text-black/45 dark:text-white/45">
        <span role="columnheader">Signal</span>
        <span role="columnheader">From</span>
        <span role="columnheader">Adjust</span>
        <span role="columnheader">Preview</span>
        <span role="columnheader">Status</span>
      </div>
      {rows.length === 0 && <p className="m-0 px-3 py-3 text-xs text-black/45 dark:text-white/45">No Signal matches.</p>}
      {rows.map((r) => (
        <button
          key={r.index}
          role="row"
          aria-selected={selected === r.index}
          aria-label={`Signal ${r.name}`}
          onClick={() => onSelect(r.index)}
          className={`grid w-full grid-cols-[minmax(7rem,1.2fr)_minmax(6rem,1fr)_minmax(5rem,1fr)_minmax(5rem,0.8fr)_minmax(6rem,0.9fr)] items-center gap-2 border-t border-black/5 dark:border-white/5 px-3 py-2 text-left text-[13px] ${selected === r.index ? 'bg-blue-600/10' : 'hover:bg-black/[0.03] dark:hover:bg-white/[0.04]'}`}
        >
          <span role="cell" className="truncate font-medium" title={r.reads ? `${r.name} - reads ${r.reads}` : r.name}>{r.name}</span>
          <span role="cell" className="truncate text-black/55 dark:text-white/55" title={r.from}>{r.from}</span>
          <span role="cell" className="truncate text-black/55 dark:text-white/55" title={r.adjust}>{r.adjust}</span>
          <span role="cell" className={`truncate font-medium ${r.preview === 'empty' ? 'text-black/40 dark:text-white/40 font-normal' : ''}`}>{r.preview}</span>
          <span role="cell" className={`flex items-center gap-1.5 truncate ${text[r.status]}`}>
            <span aria-hidden className={`inline-block h-2 w-2 shrink-0 rounded-full ${dot[r.status]}`} />
            {r.statusText}
          </span>
        </button>
      ))}
    </div>
  );
}
